import { IonRadio } from "@ionic/react";
import classnames from "classnames";
import { ComponentProps, ReactNode } from "react";

import RequiredFieldIndicator from "@components/v1/fields/RequiredFieldIndicator";
import styles from "@components/v2/forms/RadioButton.module.css";

type Props = Pick<ComponentProps<typeof IonRadio>, "className" | "disabled" | "onIonBlur" | "value"> & {
  label?: string | ReactNode;
  labelPlacement?: "end" | "start";
  required?: boolean;
};

const RadioButton = ({
  className,
  disabled = false,
  label,
  labelPlacement = "end",
  onIonBlur,
  required = false,
  value
}: Props) => (
  // eslint-disable-next-line react/forbid-elements
  <IonRadio
    className={classnames("component-RadioButton", styles.radioInput, className)}
    disabled={disabled}
    labelPlacement={labelPlacement}
    mode="md"
    onIonBlur={onIonBlur}
    value={value}
  >
    {label}
    {required && <RequiredFieldIndicator />}
  </IonRadio>
);

export default RadioButton;
